import clsx from "clsx";

import { NavLink } from "components/NavLink";

/**
 * Renders a link to a brand based on the provided brand ID.
 *
 * @param {Object} props - The component props.
 * @param {string} props._id - The ID of the brand.
 * @param {Object} props.data
 * @returns {JSX.Element} The rendered BrandLink component.
 */
export const BrandLink = ({ _id, data }) => {
  let text;
  let muted = true;
  if (!_id) {
    text = "";
  } else if (!data?.brand_id?.name && !data?.name) {
    text = "Can not display brand data.";
  } else {
    text = data.brand_id?.name || data.name;
    muted = false;
  }
  const linkClassName = clsx("p-0", {
    "small text-muted": muted,
    "link-accent-dark": !muted,
  });
  return (
    <NavLink className={linkClassName} to={`/brands/${_id}`}>
      {text}
    </NavLink>
  );
};
